<ng-content></ng-content>
<div class="flex">
  <hr app-modal-divider />
  <button type="button" app-icon-button (click)="onClose()" class="!p-0">
    <svg-icon class="h-8 w-8 select-none" src="assets/icons/icon-close-fine.svg"></svg-icon>
  </button>
</div>
